export default [
    { value: 'Newest First', id: 'newest' },
    { value: 'Oldest First', id: 'oldest' },
    { value: 'Shuffle', id: 'shuffle' },
];
